module.exports = __webpack_public_path__ + "img/electronic_electric_pending_zone.d91ffc8c.svg";